import axios, { getData } from 'lib/axios'

export const getAllJobBoard = async (companyUuid, searchItem, positionType, jobId, cityName) => {
  const response = await axios.get(
    `/job-board/jobs/${companyUuid}?${searchItem}&${positionType}&${jobId}&${cityName}`
  )
  return getData(response)
}

export const getSpecificJobBoard = async (companyUuid, id) => {
  const response = await axios.get(`/job-board/jobs/${companyUuid}/${id}`)
  return getData(response)
}

export const getBackground = async (companyUuid) => {
  const response = await axios.get(`/job-board/jobs/${companyUuid}/background`)
  return getData(response)
}

export const getCity = async (companyUuid) => {
  const response = await axios.get(`/job-board/jobs/${companyUuid}/city`)
  return getData(response)
}

export const postJobBoardApplicationForm = async (companyUuid, data) => {
  axios.defaults.headers['Content-Type'] = 'multipart/form-data'
  const response = await axios.post(`/job-board/jobs/${companyUuid}/apply-jobs`, data)
  return getData(response)
}
